
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { logError } from "@/utils/errorLogger";
import { useAuth } from "@/contexts/auth";

export const useAuthCheck = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { user } = useAuth();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // First check if we already have the user from context
        if (user) {
          console.log(`Edit product page accessed by authenticated user: ${user.email}`);
          return; // User is already authenticated, no need to redirect
        }

        // If not in context, check session as fallback
        const { data } = await supabase.auth.getSession();
        if (!data.session) {
          console.log("No authenticated user for edit product, redirecting to auth");
          toast({
            title: "Authentication required",
            description: "You need to be logged in to edit products",
            variant: "destructive",
          });
          navigate("/auth");
        } else {
          console.log(`Session found for user: ${data.session.user.email}`);
        }
      } catch (error) {
        console.error("Error checking auth for edit product:", error);
        logError({
          type: "api",
          message: "Failed to check authentication status in edit product",
          stack: error instanceof Error ? error.stack : undefined
        });
      }
    };
    
    checkAuth();
  }, [navigate, toast, user]);
};
